import React, { Component } from "react";
import PropTypes from "prop-types";

import { SETTINGS_PAGE_LINK } from "config";
import deviceServices from "services/deviceServices";
import localize from "lang/localize";
import PostIframe from "../shared/PostIframe/PostIframe";

const propTypes = {
  sessionKey: PropTypes.string.isRequired,
  language: PropTypes.string
};

class Settings extends Component {
  render() {
    /*
      Because Settings page's topbar uses a regular history.go(-1),
      we need a framing method such that the frames will not affect
      the browser history. Thus, <object> will be better than <iframe>.
      See: https://stackoverflow.com/questions/924946/use-of-iframe-or-object-tag-to-embed-web-pages-in-another/32854398#32854398
    */
    return (
      <div
        className={
          "fullscreen-frame-wrap" +
          (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
        }
      >
        <PostIframe
          title={localize("nav_bar_title_settings_text", this.props.language)}
          hiddenFields={{
            session_key: this.props.sessionKey
          }}
          url={SETTINGS_PAGE_LINK}
        />
      </div>
    );
  }
}

Settings.propTypes = propTypes;

export default Settings;
